export default {
  label: {
    en: 'Password',
  },
}
